import { createAction, props } from '@ngrx/store';
import { CollectionTypeParams } from './collection-type.models';

export const SetCollectionType = createAction('[Collection type] Set data', props<CollectionTypeParams & { previousOrderTypeId?: Nullable<number> }>());

export const PatchOrderTypeIdCollectionTypeValue = createAction('[Collection type] Patch order type id data', props<{ orderTypeId?: number }>());

export const PatchAddressCollectionTypeValue = createAction('[Collection type] Patch address data', props<{ address?: OLO.DTO.AddressSugestionDto }>());

export const PatchDetailsCollectionTypeValue = createAction('[Collection type] Patch details data', props<{ details: APICommon.OrderTypeDetailDefinitionExtended[] }>());

export const ResetCollectionTypeAddressAndDetails = createAction('[Collection type] Reset data - address and details');
